
import { put, take, fork, cancel, select, call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { replace } from 'react-router-redux';

import * as actions from 'actions';
import * as api from 'api';
import queries, { normalizeForumQuery } from 'forumQueries';
import { getForumPaging } from 'selectors';
import { isLiveNow } from 'forumLiveStatus';
import { optimisticUpdateMaker, socketRequestWithErrorChecks } from 'utils/sagas';

export function* watchForForumQueryChange() {
  let task = null;

  while(true) { // eslint-disable-line no-constant-condition
    const { payload } = yield take('@@router/LOCATION_CHANGE');
    const isForumFilteredThreadsList = payload.pathname === '/forum';
    const isForumThreadProfile = payload.pathname.indexOf('/forum/threads/') === 0;
    const isAskKooth = payload.pathname === '/forum/ask-kooth';

    if(isForumFilteredThreadsList || isForumThreadProfile || isAskKooth) {
      if(task) {
        yield cancel(task);
        task = null;
      }

      if(isForumFilteredThreadsList || isAskKooth) {
        let query;

        if(isForumFilteredThreadsList) {
          query = normalizeForumQuery(payload.query);
        }
        else {
          query = {askKooth: 'true'};
        }

        const queryString = JSON.stringify(query);
        let page = 1;

        if(payload.action === 'POP') {
          const paging = yield select(getForumPaging, 'forumThreads', { queryString });
          page = paging.page;
        }

        yield put(actions.forumThreadsFetch(page, query, queryString));
      }

      if(isForumThreadProfile) {
        task = yield fork(loadSidePanel);
      }
    }
  }
}

function *loadSidePanel() {
  const query = queries['Popular'];
  const queryString = JSON.stringify(query);
  yield put(actions.forumSidebarThreadsFetch(1, query, queryString));
}

const follow = optimisticUpdateMaker({
  idKey: 'forumThreadId',
  localUpdateType: actions.FORUM_THREAD_UPDATE,
  successType: actions.FORUM_THREAD_FOLLOW_SUCCESS,
  errorType: actions.FORUM_THREAD_FOLLOW_ERROR,
  remoteUpdateActionCreator: function* (localUpdateAction) {
    if(localUpdateAction.updates.followed !== undefined) {
      return actions.forumThreadFollow(localUpdateAction.forumThreadId, localUpdateAction.updates.followed);
    }
  },
  localUpdateActionCreator: function* (lastRemoteState, errorAction) {
    return actions.forumThreadUpdate(errorAction.forumThreadId, null, lastRemoteState);
  }
});

export function* watchForSuccessfullyCreatedForumThread() {
  while(true) { // eslint-disable-line no-constant-condition
    yield take(actions.FORUM_THREAD_CREATE_SUCCESS);
    yield put(actions.forumContributeEditingReset());
    yield put(actions.infoShow('success', 'Your post was successfully sent!'));
  }
}

export function* watchForWatchOrUnwatch(socket) {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take([
      actions.FORUM_THREAD_WATCH,
      actions.FORUM_THREAD_UNWATCH
    ]);
    const { forumThread } = action;

    if(action.type === actions.FORUM_THREAD_WATCH) {
      if(isLiveNow(forumThread)) {
        yield call(socketRequestWithErrorChecks, socket, socket.forumThreadWatch, action, forumThread.id);
      }
      else {
        yield put(replace(`/forum/lobby/${forumThread.id}`));
      }
    }
    else {
      yield call(socketRequestWithErrorChecks, socket, socket.forumThreadUnwatch, action, forumThread.id);
    }
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.FORUM_THREADS_FETCH, request(api.forumThreadsFetch, 'page', 'query')),
    fork(takeLatest, actions.FORUM_SIDEBAR_THREADS_FETCH, request(api.forumThreadsFetch, 'page', 'query')),
    fork(takeLatest, actions.FORUM_THREAD_PROFILE_FETCH, request(api.forumThreadProfileFetch, 'forumThreadId')),
    fork(takeLatest, actions.FORUM_THREAD_FOLLOW, request(api.forumThreadFollow, 'forumThreadId', 'followed')),
    fork(takeLatest, actions.FORUM_THREAD_CREATE, request(api.forumThreadCreate, 'forumThreadProps')),
    fork(watchForForumQueryChange),
    fork(follow),
    fork(watchForSuccessfullyCreatedForumThread),
    fork(watchForWatchOrUnwatch, socket)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/sagas.js
 **/